import type { PrematchContentQuery } from './type';

export function createSearchParams(query: PrematchContentQuery) {
  const params = new URLSearchParams();

  for (const queryKey in query) {
    const value = query[queryKey as keyof typeof query];

    if (value) {
      params.set(queryKey, value.toString());
    }
  }

  return params;
}
